export type IntegerWordsOptions = {
  andWord?: boolean; 
};

export function parseNumberish(v: unknown): number | null {
  if (v == null) return null;
  if (typeof v === "number") return Number.isFinite(v) ? v : null;
  if (typeof v !== "string") return null;
  const s = v.trim();
  if (!s) return null;

  const lastDot = s.lastIndexOf(".");
  const lastComma = s.lastIndexOf(",");
  let normalized = s;
  if (lastDot >= 0 && lastComma >= 0) {
    normalized = lastComma > lastDot ? s.replace(/\./g, "").replace(",", ".") : s.replace(/,/g, "");
  } else {
    normalized = s.replace(/,/g, "");
  }
  const n = Number(normalized);
  return Number.isFinite(n) ? n : null;
}

export function integerToEnglishWords(n: number, opts: IntegerWordsOptions = {}): string {
  if (!Number.isFinite(n)) return "";
  const negative = n < 0;
  n = Math.trunc(Math.abs(n));
  if (n === 0) return "zero";

  const ones = ["zero","one","two","three","four","five","six","seven","eight","nine","ten","eleven","twelve","thirteen","fourteen","fifteen","sixteen","seventeen","eighteen","nineteen"];
  const tens = ["","","twenty","thirty","forty","fifty","sixty","seventy","eighty","ninety"];
  const scales = ["","thousand","million","billion","trillion","quadrillion","quintillion"];

  const chunkToWords = (num: number): string => {
    const parts: string[] = [];
    const hundred = Math.floor(num / 100);
    const rest = num % 100;
    if (hundred > 0) {
      parts.push(`${ones[hundred]} hundred`);
      if (rest > 0 && opts.andWord) parts.push("and");
    }
    if (rest > 0) {
      if (rest < 20) parts.push(ones[rest]);
      else {
        const t = Math.floor(rest / 10), o = rest % 10;
        parts.push(o ? `${tens[t]}-${ones[o]}` : tens[t]);
      }
    }
    return parts.join(" ");
  };

  const groups: number[] = [];
  while (n > 0) { groups.push(n % 1000); n = Math.floor(n / 1000); }

  const words: string[] = [];
  for (let i = groups.length - 1; i >= 0; i--) {
    if (groups[i] === 0) continue;
    const w = chunkToWords(groups[i]);
    const scale = scales[i] ?? "";
    words.push(scale ? `${w} ${scale}` : w);
  }
  const out = words.join(" ");
  return negative ? `minus ${out}` : out;
}

export function numberToLettersEN(value: unknown, opts: IntegerWordsOptions = {}): string {
  const n = parseNumberish(value);
  if (n == null) return "";

  const abs = Math.abs(n);
  const totalCents = Math.round(abs * 100);
  const intPart = Math.floor(totalCents / 100);
  const cents = totalCents % 100;


  if (intPart > 10_000_000) return "";

  let res = integerToEnglishWords(n < 0 ? -intPart : intPart, opts);
  if (cents > 0) res = `${res} and ${String(cents).padStart(2, "0")}/100`;
  return res;
}